import React, { useState, useEffect } from "react";
import "./HeroInner.css";

function HeroInner({ title, subtitle, bg }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = bg;

    img.onload = () => {
      setLoaded(true);
    };
  }, [bg]);

  return (
    <section
      className={`hero-inner ${loaded ? "loaded" : ""}`}
      style={{
        backgroundImage: loaded ? `url(${bg})` : "none"
      }}
    >
      <div className="hero-overlay">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </section>
  );
}

export default HeroInner;